import { otgMsgGenerator } from "@fns";
import { EAppStateType, useAppStore } from "@store/appStore";
import { EMessageType } from "@types";
import { useCallback } from "react";
import { shallow } from "zustand/shallow";

type TSendUploadAttachment = (event: string, payload?: any) => unknown;

export const getClipboardFile = (
  clipboardData?: Pick<DataTransfer, "files" | "items"> | null,
) => {
  const fileFromFiles = clipboardData?.files?.[0];

  if (fileFromFiles) {
    return fileFromFiles;
  }

  const clipboardItems = Array.from(clipboardData?.items || []);
  for (const item of clipboardItems) {
    if (item.kind !== "file") {
      continue;
    }

    const file = item.getAsFile();
    if (file) {
      return file;
    }
  }

  return null;
};

export const useAttachmentUpload = (send: TSendUploadAttachment) => {
  const { acceptFileTypes, appState, room, token } = useAppStore((state) => {
    return {
      token: state.token,
      room: state.room,
      appState: state.appState,
      acceptFileTypes: state.settings.acceptFileTypes,
    };
  }, shallow);

  const uploadFile = useCallback(
    async (file?: File | null) => {
      if (
        !file ||
        !room?._id ||
        appState.state === EAppStateType.UNAUTHORIZED
      ) {
        return false;
      }

      const outgoing = await otgMsgGenerator({
        type: EMessageType.ATTACHMENT,
        file,
        rid: room._id,
        token,
        acceptFileTypes,
      });

      if (!outgoing) {
        return false;
      }

      send("UPLOAD_ATTACHMENT", outgoing);
      return true;
    },
    [acceptFileTypes, appState.state, room, send, token],
  );

  return {
    uploadFile,
    isUploadDisabled:
      appState.state === EAppStateType.UNAUTHORIZED || !room?._id,
  };
};
